var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-preorder"},[_c('a',{attrs:{"href":_vm.getPreorderURL},on:{"click":function($event){return _vm.movePreorder()}}},[_vm._v("사전예약")])])}
var staticRenderFns = []

export { render, staticRenderFns }